<img  *ngIf="showLight" [class]="class" [src]="getAsset(rating)" [alt]="getAlt(rating) | translate">
